import {Button, InputNumber, Row} from "antd";
import {ProductDisplayWidget} from "../fulfillment/ProductDisplayWidget";

export const ProductQuantitySelectWidget = ({product, onProductSelect, quantity, onQuantityChange, onSave, refresh, onApiFail, props}) => {
    const rowStyle = {paddingTop: '5px', paddingBottom: '5px'}
    const saveDisabled = (product === null) || (product === undefined) || (quantity === null) || (quantity === undefined);

    const onSaveProduct = () => {
        if (onSave) onSave();
    }

    return  <div>
        <Row style={rowStyle}>
            <ProductDisplayWidget productId={product ? product.id : null} onSelect={onProductSelect} refresh={refresh} onApiFail={onApiFail} />
        </Row>
        <Row style={rowStyle}><InputNumber style={{width:150}} placeholder={'Quantity'} value={quantity} onChange={onQuantityChange}/></Row>
        <Row style={rowStyle}><Button disabled={saveDisabled} onClick={onSaveProduct}>Save Product</Button></Row>
    </div>
}